import React from "react";
import "./index.sass";

const AppPagination = ({
  paginationRange,
  currentPage,
  totalPages,
  onPageChange,
  onEllipsisClick,
}) => (
  <div className="app-pagination">
    <button
      type="button"
      className="app-pagination__arrow"
      onClick={() => onPageChange(Math.max(1, currentPage - 1))}
      disabled={currentPage === 1}
      aria-label="Previous page"
    >
      ‹
    </button>

    {paginationRange.map((item, index) =>
      item.type === "ellipsis" ? (
        <button
          type="button"
          key={`ellipsis-${item.direction}-${index}`}
          className="app-pagination__ellipsis"
          onClick={() => onEllipsisClick(item.direction)}
          aria-label={`Show more pages to the ${item.direction}`}
        >
          …
        </button>
      ) : (
        <button
          type="button"
          key={item.value}
          className={`app-pagination__button ${
            currentPage === item.value ? "app-pagination__button--active" : ""
          }`}
          onClick={() => onPageChange(item.value)}
        >
          {item.value}
        </button>
      ),
    )}

    <button
      type="button"
      className="app-pagination__arrow"
      onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
      disabled={currentPage === totalPages}
      aria-label="Next page"
    >
      ›
    </button>
  </div>
);

export default AppPagination;
